import { render, staticRenderFns } from "./politicsProjectManage.vue?vue&type=template&id=4b2c110e&scoped=true"
import script from "./politicsProjectManage.vue?vue&type=script&lang=js"
export * from "./politicsProjectManage.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectManage.vue?vue&type=style&index=0&id=4b2c110e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c110e",
  null
  
)

export default component.exports